<x-y-graph [chartTitle]="currentTitle" [chartId]="'incidentsCreatedChart'" [widthHeightRatio]="0.37" 
    [graphPair]="graphPair" [showKey]="true" [hasForecast]="true" [flagMap]="dataFlagMap">
    <div class="graph-date-controls" chart-controls>
        <div class="custom-radio-group">
            <label class="custom-radio-button-container" for="incidents-created-option">Incidents
                <input type="radio" value="incidents" [(ngModel)]="dataShown" (change)="setDataShown($event.target.value)" name="incident-data-toggle" id="incidents-created-option">
                <span class="custom-radio-button"></span>
            </label>
            <label class="custom-radio-button-container" for="storage-option">Storage
                <input type="radio" value="storage" [(ngModel)]="dataShown" (change)="setDataShown($event.target.value)" name="incident-data-toggle" id="storage-option">
                <span class="custom-radio-button"></span>
            </label>
        </div>
        <date-selector (selectedDateChange)="onDateChange($event)" [selectedDate]="selectedDate" [startDate]="earliestSelectionDate" [endDate]="latestSelectionDate"/>
    </div>
</x-y-graph>
